/**
 * UTM Capture — Persiste parâmetros UTM da URL no sessionStorage
 *
 * Captura no first load e disponibiliza para enriquecimento de eventos
 * custom (whatsapp_click, booking_click, etc).
 */

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;
type UtmKey = (typeof UTM_KEYS)[number];
type UtmParams = Partial<Record<UtmKey, string>>;

const SESSION_KEY = '_ga_utm';

/**
 * Captura UTMs da URL atual e persiste no sessionStorage.
 * Só sobrescreve se a URL atual tiver UTMs (último clique de campanha vence).
 */
export function captureUtmFromUrl(): void {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  const hasUtm = UTM_KEYS.some(k => params.has(k));
  if (!hasUtm) return;

  const utm: UtmParams = {};
  for (const key of UTM_KEYS) {
    const val = params.get(key);
    if (val) utm[key] = val;
  }

  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(utm));
  } catch {
    /* Safari private mode */
  }
}

/**
 * Retorna UTMs capturados na sessão atual (ou objeto vazio).
 */
export function getSessionUtm(): UtmParams {
  if (typeof window === 'undefined') return {};

  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? (JSON.parse(raw) as UtmParams) : {};
  } catch {
    return {};
  }
}
